import axios from 'axios';
import CustomRequest from './customRequest';
function wegicRequest(config) {
    const { originalInstance } = config;
    if (originalInstance) {
        return axios.create(config);
    }
    return new CustomRequest(config);
}
export * from './abortControllerManage';
export { isPermissionError } from './interceptor';
export { wegicRequest as WegicRequest };
